// extracted by mini-css-extract-plugin
module.exports = {"commentButton":"Comments_commentButton__3tfaA","comments__container":"Comments_comments__container__31sRA"};